export const T = {
  en_GB: {
    representativeRequired: "The representative's name and national ID are required.",
    nameRequired: "Name is required",
    countryRequired: "Country is required",
    ssnRequired: "SSN is required",
    birthDateRequired: "Date of birth is required",
    unexpectedError: "An unexpected error occurred",
  },
  nb_NO: {
    representativeRequired: "Representantens navn og fødselsnummer er påkrevd.",
    nameRequired: "Navn er påkrevd",
    countryRequired: "Land er påkrevd",
    ssnRequired: "Fødselsnummer er påkrevd",
    birthDateRequired: "Fødselsdato er påkrevd",
    unexpectedError: "En uventet feil oppstod",
  },
} as const;
